import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { makeOpaque } from 'app/shared/utils/colors';
import { Box, Typography } from 'app/shared/components/atoms';

interface Props {
  title: string;
  backgroundImageUrl: string;
}

const ArtistHero: React.FC<React.PropsWithChildren<Props>> = ({
  backgroundImageUrl,
  title,
}) => {
  const { colors } = useCurrentTheme();

  return (
    <Box
      as="header"
      backgroundColor={makeOpaque(colors.primary.black.base, 0.5)}
      backgroundImage={backgroundImageUrl}
      minHeight="450px"
      maxHeight="532px"
      data-qaid="artist-hero-wrapper"
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={[8, 8, 12, 12]}
    >
      <Typography
        as="h1"
        fontSize="fontSize700"
        fontFamily="title"
        color={colors.primary.white.lightest}
        data-qaid="artist-hero-title"
      >
        {title}
      </Typography>
    </Box>
  );
};

export default ArtistHero;
